<template>
	<div class="wrapper">
		<img class="backgroundImg" src="@/assets/image/openApp/bg.png" alt="">
		<div class="centerText">
			<p>去电巢APP</p>
			<p>看更多精彩直播</p>
			<p>品更多精彩内容</p>
		</div>
		<div class="button">
			打开APP
			<WxOpenTag :extinfo="target" ref="wxopentag" />
		</div>
	</div>
</template>
<script>
import utils from '@/utils/utils'
import WxOpenTag from '@/components/WxOpenTag' 
export default {
	components: {
		WxOpenTag
	},
	data(){
		return {
			target: this.$route.query.target || ''
		}
	},
	mounted(){
		this.$refs.wxopentag.register()
	},
	methods: {
		redirectTo(target){
			if(!target){
				target = this.target
			}
			utils.callNativeApp(encodeURIComponent(target))
		}
	}
}
</script>

<style scoped>
.wrapper{
	width: 100%;
	position: relative;
}
.backgroundImg{
	max-width: 100%;
	height: auto;
}
.centerText{
	position: absolute;
	width: 100%;
	top: 0px;
	padding-top: 35%;
	font-size: 30px;
	color: #fff;
	text-align: center;
	letter-spacing: 3px;
	line-height: 1.5;
}
.button{
	position: relative;
	width: 60%;
	margin: 20px auto 50px;
	padding: 10px;
	font-size: 20px;
	color: #fff;
	text-align: center;
	letter-spacing: 3px;
	background-color: #f00;
	border-radius: 30px;
}
</style>